<p-fluid>
    <div class="card flex flex-col gap-6 max-w-xl">
        <div class="flex items-center justify-between">
            <div class="font-semibold text-xl">Finera Integration</div>
            <div class="flex items-center gap-2">
                @if (dirty()) {
                    <p-button label="Reset all" icon="pi pi-undo" severity="secondary" outlined size="small" (click)="resetAll()" />
                }
                <p-button label="Fill from…" icon="pi pi-download" severity="secondary" outlined size="small" (click)="openImportDialog()" />
            </div>
        </div>

        <div class="flex items-center gap-3">
            <p-checkbox inputId="finera-enabled" [binary]="true" [ngModel]="draft().IsEnabled" (ngModelChange)="setField('IsEnabled', $event)" />
            <label for="finera-enabled">Finera Enabled</label>
            @if (draft().IsEnabled !== realm().Finera.IsEnabled) {
                <p-button icon="pi pi-undo" severity="warn" [text]="true" [rounded]="true" size="small" pTooltip="Reset" (onClick)="setField('IsEnabled', realm().Finera.IsEnabled)" />
            }
        </div>

        <div>
            <label class="block font-medium mb-1">Base URL</label>
            <p-inputgroup>
                <input pInputText class="w-full" [ngModel]="draft().BaseUrl" (ngModelChange)="setField('BaseUrl', $event ?? '')" />
                @if (draft().BaseUrl !== realm().Finera.BaseUrl) {
                    <p-inputgroup-addon>
                        <p-button icon="pi pi-undo" severity="warn" [text]="true" [rounded]="true" size="small" pTooltip="Reset" (onClick)="setField('BaseUrl', realm().Finera.BaseUrl)" />
                    </p-inputgroup-addon>
                }
            </p-inputgroup>
        </div>

        <div class="font-semibold">Deposit</div>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
                <label class="block font-medium mb-1">Group ID</label>
                <p-inputgroup>
                    <input pInputText class="w-full" [ngModel]="draft().Deposit.GroupId" (ngModelChange)="setDeposit('GroupId', $event ?? '')" />
                    @if (draft().Deposit.GroupId !== realm().Finera.Deposit.GroupId) {
                        <p-inputgroup-addon>
                            <p-button icon="pi pi-undo" severity="warn" [text]="true" [rounded]="true" size="small" pTooltip="Reset" (onClick)="setDeposit('GroupId', realm().Finera.Deposit.GroupId)" />
                        </p-inputgroup-addon>
                    }
                </p-inputgroup>
            </div>
            <div class="md:col-span-2">
                <label class="block font-medium mb-1">Control Key</label>
                <p-inputgroup>
                    <input pInputText class="w-full" [ngModel]="draft().Deposit.ControlKey" (ngModelChange)="setDeposit('ControlKey', $event ?? '')" />
                    @if (draft().Deposit.ControlKey !== realm().Finera.Deposit.ControlKey) {
                        <p-inputgroup-addon>
                            <p-button icon="pi pi-undo" severity="warn" [text]="true" [rounded]="true" size="small" pTooltip="Reset" (onClick)="setDeposit('ControlKey', realm().Finera.Deposit.ControlKey)" />
                        </p-inputgroup-addon>
                    }
                </p-inputgroup>
            </div>
        </div>

        @if (isSkill()) {
            <div class="font-semibold">Withdraw</div>
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                    <label class="block font-medium mb-1">Group ID</label>
                    <p-inputgroup>
                        <input pInputText class="w-full" [ngModel]="withdrawDraft().GroupId" (ngModelChange)="setWithdraw('GroupId', $event ?? '')" />
                        @if (withdrawDraft().GroupId !== baseWithdraw().GroupId) {
                            <p-inputgroup-addon>
                                <p-button icon="pi pi-undo" severity="warn" [text]="true" [rounded]="true" size="small" pTooltip="Reset" (onClick)="setWithdraw('GroupId', baseWithdraw().GroupId)" />
                            </p-inputgroup-addon>
                        }
                    </p-inputgroup>
                </div>
                <div class="md:col-span-2">
                    <label class="block font-medium mb-1">Control Key</label>
                    <p-inputgroup>
                        <input pInputText class="w-full" [ngModel]="withdrawDraft().ControlKey" (ngModelChange)="setWithdraw('ControlKey', $event ?? '')" />
                        @if (withdrawDraft().ControlKey !== baseWithdraw().ControlKey) {
                            <p-inputgroup-addon>
                                <p-button icon="pi pi-undo" severity="warn" [text]="true" [rounded]="true" size="small" pTooltip="Reset" (onClick)="setWithdraw('ControlKey', baseWithdraw().ControlKey)" />
                            </p-inputgroup-addon>
                        }
                    </p-inputgroup>
                </div>
                <div>
                    <label class="block font-medium mb-1">Connecting Party Name</label>
                    <p-inputgroup>
                        <input pInputText class="w-full" [ngModel]="withdrawDraft().ConnectingPartyName" (ngModelChange)="setWithdraw('ConnectingPartyName', $event ?? '')" />
                        @if (withdrawDraft().ConnectingPartyName !== baseWithdraw().ConnectingPartyName) {
                            <p-inputgroup-addon>
                                <p-button icon="pi pi-undo" severity="warn" [text]="true" [rounded]="true" size="small" pTooltip="Reset" (onClick)="setWithdraw('ConnectingPartyName', baseWithdraw().ConnectingPartyName)" />
                            </p-inputgroup-addon>
                        }
                    </p-inputgroup>
                </div>
                <div class="md:col-span-2">
                    <label class="block font-medium mb-1">RSA Private Key (PEM)</label>
                    <div class="flex gap-2 items-start">
                        <textarea pTextarea class="w-full font-mono text-sm" [rows]="6" [autoResize]="false" [ngModel]="withdrawDraft().RsaPrivateKeyPem" (ngModelChange)="setWithdraw('RsaPrivateKeyPem', $event ?? '')"></textarea>
                        @if (withdrawDraft().RsaPrivateKeyPem !== baseWithdraw().RsaPrivateKeyPem) {
                            <p-button icon="pi pi-undo" severity="warn" [text]="true" [rounded]="true" size="small" pTooltip="Reset" (onClick)="setWithdraw('RsaPrivateKeyPem', baseWithdraw().RsaPrivateKeyPem)" />
                        }
                    </div>
                </div>
            </div>
        }
    </div>
</p-fluid>

<!-- Finera fill-from dialog -->
<p-dialog
    header="Fill Finera from Another Website"
    [visible]="importDialogVisible()"
    (visibleChange)="importDialogVisible.set($event)"
    [style]="{ width: '28rem' }"
    [breakpoints]="{ '960px': '90vw' }"
    [modal]="true"
>
    <div class="flex flex-col gap-4">
        <p class="m-0 text-muted-color text-sm">
            Select a source website to copy its Finera configuration into the current form. No changes will be saved until you click <strong>Save all</strong>.
        </p>
        <div>
            <label class="block font-medium mb-1">Source Website</label>
            <p-select
                class="w-full"
                [ngModel]="importSourceRealmId()"
                (ngModelChange)="importSourceRealmId.set($event)"
                [options]="importableRealms()"
                optionLabel="Domain"
                optionValue="RealmId"
                placeholder="Select website…"
                [loading]="realmService.loading()"
                appendTo="body"
            />
        </div>
    </div>
    <ng-template #footer>
        <p-button
            label="Cancel"
            text
            severity="secondary"
            (click)="importDialogVisible.set(false)"
            [disabled]="importLoading()"
        />
        <p-button
            label="Fill Fields"
            icon="pi pi-check"
            [disabled]="!importSourceRealmId()"
            [loading]="importLoading()"
            (click)="applyImport()"
        />
    </ng-template>
</p-dialog>
